const CAP = {
  "title": "Capítulo 45 — No son tus llaves, no son tus monedas",
  "sections": [
    {
      "heading": "Resumen",
      "text": "Este capítulo (“No son tus llaves, no son tus monedas”) forma parte del Manual de Autoprotección en Blockchain. Proporciona prácticas accionables para reducir la superficie de ataque y mejorar tu higiene digital."
    },
    {
      "heading": "Custodia propia",
      "text": "Si no controlas las llaves, no posees los fondos. Define política según riesgo."
    },
    {
      "heading": "Puntos clave",
      "list": [
        "Buenas prácticas concretas para el día a día.",
        "Riesgos habituales y cómo mitigarlos.",
        "Checklist final para verificar antes/después."
      ]
    },
    {
      "heading": "Checklist",
      "list": [
        "Verifiqué fuentes y dominios oficiales.",
        "Usé 2FA/TOTP o llaves físicas cuando aplica.",
        "Mantuve mis claves/seed fuera de línea y seguras."
      ]
    }
  ]
};

export default CAP;
